export default {
  resmodification_requests: "Modification Requests",
  resreview_supplier_changes: "Review and approve supplier order changes",
  resorder_id: "Order ID",
  ressupplier: "Supplier",
  resbefore: "Before",
  resafter: "After",
  resreason: "Reason",
  resstatus: "Status",
  resaction: "Action",
  respending: "Pending",
  resview: "View",
  resno_modification_requests: "No modification requests",
  resqar: "QAR",

  // NEW
  resmodification_request: "Modification Request",
  resback: "Back",
  respending_approval: "Pending Approval",
  resoriginal_items: "Original Items",
  resmodified_items: "Modified Items",
  resitem: "Item",
  resqty: "Qty",
  resprice: "Price",
  resreject_changes: "Reject Changes",
  resaccept_changes: "Accept Changes"
};